import styled from 'styled-components'
import { FaTrash } from 'react-icons/fa'

export const Trash = styled(FaTrash)`
  color: #777;
  cursor: pointer;
  margin-left: 30px;
  transition: 0.5s;
   
   &:hover{
    color: #aaa;
   }
`
export const BackButton = styled.a` 
  align-self: flex-start;
  margin: 24px 0 0 7.5%;
  cursor: pointer;
  color: #777;
  text-decoration: none;
`